import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import FetchContext from '../../context/fetch/FetchContext'
import Page from '../pages/Page'
import SchemaTable from '../table/SchemaTable'
import FirmCreateDialog from './FirmCreateDialog'

const FIRMS_QUERY_KEY = ['firms']

const COLUMNS = [
    { Header: 'שם', accessor: 'name' },
    { Header: 'תיבת דואר', accessor: 'mailbox' },
    { Header: 'משתמשים', accessor: 'userCount' },
]

export default function FirmsPage() {
    const fetcher = useContext(FetchContext)
    const navigate = useNavigate()
    const [creating, setCreating] = useState(false)

    const { data: firms, isFetching } = useQuery({
        queryKey: FIRMS_QUERY_KEY,
        queryFn: () => fetcher.fetchFirms(),
        enabled: fetcher.isAuthenticated(),
    })

    const commands = [
        {
            scheme: 'button',
            label: 'משרד חדש',
            testId: 'firm-create',
            onClick: () => setCreating(true),
            position: 'start',
        },
    ]

    return (
        <Page
            commands={commands}
            className="firms"
            title="משרדים"
            busy={isFetching}
        >
            <SchemaTable
                data={firms ?? []}
                columns={COLUMNS}
                onRowClick={(event, row) => navigate(`/firms/${row.original.id}`)}
                canSearch={false}
            />
            <FirmCreateDialog
                open={creating}
                onClose={() => setCreating(false)}
            />
        </Page>
    )
}
